import { DEMO_TOKEN } from "manifest-bridge-core/src/index";
import { NewTransferStatusType, TransferInstruction } from "../../class/transferInstruction";
import { completeDestinationAccountResponse, sampleCompleteSourceAccountRes } from "../../api/mockAPIResponse";

const sampleAccessToken = "access-token";
const sampleClientId = "client-id";
const development = "development";
const production = "production";
const sampleTransferIntent = "sampleTransferIntent";

export const sampleTransferInBridgeUrl = `http://localhost:3000?accessToken=${DEMO_TOKEN}&clientId=${sampleClientId}&environment=${development}&transferIntentId=${sampleTransferIntent}--transfer-in&userId=undefined`;
export const sampleTransferOutBridgeUrl = `http://localhost:3000?accessToken=${DEMO_TOKEN}&clientId=${sampleClientId}&environment=${development}&transferIntentId=${sampleTransferIntent}--transfer-out&userId=undefined`;
export const sampleTransferStatusBridgeUrl = `http://localhost:3000?accessToken=${DEMO_TOKEN}&clientId=${sampleClientId}&environment=${development}&transferIntentId=undefined&userId=userId`;

export const sampleTransferInDevUrl = `http://localhost:3000?accessToken=${sampleAccessToken}&clientId=${sampleClientId}&environment=${development}&transferIntentId=${sampleTransferIntent}&userId=undefined`;
export const sampleTransferInProdUrl = `http://localhost:3000?accessToken=${sampleAccessToken}&clientId=${sampleClientId}&environment=${production}&transferIntentId=${sampleTransferIntent}&userId=undefined`;

export const sampleTransferInNoAccessToken = `http://localhost:3000?accessToken=undefined&clientId=${sampleClientId}&environment=${development}&transferIntentId=${sampleTransferIntent}&userId=undefined`;
export const sampleTransferInNoClientId = `http://localhost:3000?accessToken=${sampleAccessToken}&clientId=undefined&environment=${development}&transferIntentId=${sampleTransferIntent}&userId=undefined`;

export const sampleTransferInstructions: TransferInstruction[] = [
  {
    transferInstructionId: 0,
    transferInstructionStatus: "SCHEDULE_PHONE_CALL" as NewTransferStatusType,
    transferExternalStatus: "Additional Information Needed",
    transferExternalStatusDescription:
      "Additional details are needed to complete your transfer. Your transfer specialist will follow up.",
    scheduledPhoneCall: null,
    source: sampleCompleteSourceAccountRes,
    destinations: [completeDestinationAccountResponse],
    transferId: 0,
  },
  {
    transferInstructionId: 123,
    transferInstructionStatus: NewTransferStatusType.PROCESSING,
    transferExternalStatus: "Processing",
    transferExternalStatusDescription: "Manifest is processing your transfer; no action is needed.",
    scheduledPhoneCall: null,
    source: sampleCompleteSourceAccountRes,
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 456,
    transferInstructionStatus: NewTransferStatusType.INITIATED_AT_SOURCE,
    transferExternalStatus: "Transfer Initiated At Source",
    transferExternalStatusDescription: "Your transfer has been initiated at the source provider.",
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "Delta Airlines Individual Retirement Account" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 789,
    transferExternalStatusDescription: "A check has been issued and sent to your destination account.",
    transferInstructionStatus: NewTransferStatusType.CHECK_SENT_TO_DESTINATION,
    transferExternalStatus: "Check Sent To Destination",
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "New York University" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 789,
    transferInstructionStatus: NewTransferStatusType.PENDING_DESTINATION,
    transferExternalStatus: "Pending Destination Account",
    transferExternalStatusDescription: "Please complete the destination account setup to proceed with your transfer.",
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "United Healthcare" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 1000,
    transferExternalStatusDescription:
      "Please complete the Roth destination account setup to proceed with your transfer.",
    transferExternalStatus: "Pending Roth Destination Account",
    transferInstructionStatus: NewTransferStatusType.PENDING_ROTH_DESTINATION,
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "Blue Cross" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 16898,
    transferExternalStatusDescription:
      "Please complete the TRAD destination account setup to proceed with your transfer.",
    transferExternalStatus: "Pending Traditional Destination Account",
    transferInstructionStatus: NewTransferStatusType.ADDITIONAL_INFORMATION_NEEDED,
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "Apple Inc" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 1001,
    transferInstructionStatus: NewTransferStatusType.SCHEDULE_PHONE_CALL,
    transferExternalStatus: "Additional Information Needed",
    transferExternalStatusDescription:
      "Additional details are needed to complete your transfer. Your transfer specialist will follow up.",
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "Google LLC" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 1002,
    transferInstructionStatus: NewTransferStatusType.COMPLETE,
    transferExternalStatus: "Transfer Complete",
    transferExternalStatusDescription: "Your transfer has been completed successfully.",
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "Microsoft LLC" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
  {
    transferInstructionId: 1003,
    transferInstructionStatus: NewTransferStatusType.CANCELLED,
    transferExternalStatus: "Transfer Canceled",
    transferExternalStatusDescription:
      "Your transfer has been canceled. For questions, contact transfers@usemanifest.com",
    scheduledPhoneCall: null,
    source: { ...sampleCompleteSourceAccountRes, planSponsor: "Bank of America" },
    destinations: [completeDestinationAccountResponse],
    transferId: 123,
  },
];
